// Hook del cierre de la venta de mostrador de accesorios.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { accessorySalesApi } from '@/api/services/retail-wizard/accessorySales.client';
import type { CreateAccessorySaleRequest } from '@/api/services/retail-wizard/accessorySales.client';
import { WIZARD_KEYS } from '@/domains/sales/wizard/api/useWizard';

/** Cierra la venta; al cerrar se relee el catálogo para que las existencias bajen. */
export function useCreateAccessorySale() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (args: { request: CreateAccessorySaleRequest; idempotencyKey: string }) =>
            accessorySalesApi.createSale(args.request, args.idempotencyKey),
        onSuccess: () => {
            void qc.invalidateQueries({ queryKey: WIZARD_KEYS.catalog('portal') });
        },
    });
}
